<template>
  <div>
    <b-card>
      <b-row>
        <b-col class="d-flex justify-content-end">
          <b-button class="btn btn-success" @click="onShowModalCreate()">Crear</b-button>
          <b-button
            class="ml-1"
            variant="success"
            size="sm"
            @click="descargarCartFar"
            v-b-tooltip.hover
            title="Descargar cartera Medicamentos"
          >
            <div v-if="descargandoExcel">
              <b-spinner small type="grow"></b-spinner>
              <label style="color: whitesmoke;">Descargando..</label>
            </div>
            <i class="fas fa-file-excel"></i>
          </b-button>
        </b-col>
      </b-row>

      <hr>

      <b-row class="my-2 mx-1">
        <h5 class="col-12">Busqueda:</h5>
        <b-form-input
          v-model="consultarfarmaco"
          placeholder="Buscar por nombre del farmaco"
          type="text"
          class="col-4"
        />

        <v-select
          id="establecimiento"
          v-model="consultarestablecimiento"
          placeholder="Buscar por establecimiento."
          :options="establecimientos"
          :reduce="option => option.value"
          label="text"
          class="col-3"
        />

        <v-select
          id="estado"
          v-model="estado"
          placeholder="Seleccionar estado."
          :options="estados"
          :reduce="option => option.value"
          label="text"
          class="col-2"
        />

        <b-col class="ml-1 col-3 d-flex">
          <b-button variant="primary" @click="cambiarEstadoIds" class="mr-1">
            <span style="color: white;">Cambiar estado</span>
          </b-button>

          <b-button variant="primary" @click="buscarFarmaco">
            <font-awesome-icon icon="magnifying-glass" style="color: white;" />
            Buscar
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card class="principal">
        <div class="d-flex justify-content-between mb-1 mx-1">
          <div class="d-flex text-success align-items-center">
            <i class="fa-solid fa-filter"/>
            <span class="mx-1"></span>
          </div>
          <h5>Resultados: {{ totalRows }}</h5>
        </div>

        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table v-if="items.length > 0" bordered striped responsive :per-page="perPage"
              :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
              :filter-included-fields="filterOn" @filtered="onFiltered">
              <template #cell(check)="data">
                  <b-form-checkbox @change="selectedMedicament(data.item.idMedicamento)">

                  </b-form-checkbox>
              </template>
                    <template #cell(estado)="data">
                      <div class="row">
                        <label class="col-6">Iess:
                          <label :class="data.item.estadoJson.iess ? 'text-success' : 'text-danger'">
                            {{ data.item.estadoJson.iess ? 'Activo' : 'Inactivo' }}
                          </label>
                        </label>
                        <label class="col-6">Issfa:
                          <label :class="data.item.estadoJson.issfa ? 'text-success' : 'text-danger'">
                            {{ data.item.estadoJson.issfa ? 'Activo' : 'Inactivo' }}
                          </label>
                        </label>

                        <label class="col-6">Isspol:
                          <label :class="data.item.estadoJson.isspol ? 'text-success' : 'text-danger'">
                            {{ data.item.estadoJson.isspol ? 'Activo' : 'Inactivo' }}
                          </label>
                        </label>
                        <label class="col-6">Particul:
                          <label :class="data.item.estadoJson.particular ? 'text-success' : 'text-danger'">
                            {{ data.item.estadoJson.particular ? 'Activo' : 'Inactivo' }}
                          </label>
                        </label>
                      </div>
                    </template>
                    <template #cell(establecimientos)="data">
                        <div class="d-flex flex-column text-left">
                          <span
                            v-for="est in data.item.establecimientos"
                            :key="est.id"
                          >
                            {{ est.nombre }}:
                            <span :class="est.activo ? 'text-success' : 'text-danger'">
                              {{ est.activo ? 'Activo' : 'Inactivo' }}
                            </span>
                          </span>
                        </div>
                    </template>
                    <template #cell(acciones)="data">
                        <div class="d-flex justify-content-end">
                            <!-- Asegúrate de usar la propiedad correcta aquí, por ejemplo, `idMedicamento` -->
                            <b-button variant="info" size="sm" @click="viewItem(data.item.tokenMedicamento)">
                                <font-awesome-icon icon="magnifying-glass" style="color: white;" />
                      </b-button>
                      <b-button variant="primary" size="sm" @click="editItem(data.item.tokenMedicamento)">
                          <font-awesome-icon icon="user-pen" style="color: white;" />
                      </b-button>
                      <b-button variant="danger" size="sm" @click="removeItemid(data.item.idMedicamento)">
                          <font-awesome-icon icon="circle-xmark" style="color: white;" />
                      </b-button>
                  </div>
              </template>
          </b-table>
          <div v-else class="text-center">
              <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination v-if="items.length > 0" v-model="currentPageModificado" :total-rows="totalRows"
              :per-page="perPage" :small="true" first-number last-number class="mb-0" align="center"
              prev-class="prev-item" next-class="next-item" @change="cambiarPagina">
              <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
          </b-pagination>
        </b-col>
      </b-card>
    </b-overlay>

    <b-modal v-model="modalShow" @show="cargarComponente" title="Detalles del Medicamento" size="md">
      <component :is="componenteDinamico" v-if="componenteDinamico" :token="tokenSeleccionado"></component>
    </b-modal>

    <b-modal id="modal-editar-farmaco" size="lg" hide-footer>
      <Editarfarmaco :token="tokenSeleccionado"/>
    </b-modal>
  </div>

</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BOverlay,
  BFormGroup,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
} from 'bootstrap-vue';

import actions from '@/assets/utils/utils'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json'
import { comprobarPermisos } from "@/shared/helpers";
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'; // Update the path accordingly;
import Editarfarmaco from './Editarfarmaco.vue';

export default {
  components: {
    AppBreadcrumb,
    BCard,
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BOverlay,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    Editarfarmaco
  },
  data() {

    return {
      descargandoExcel: false,
      tokenSeleccionado: null,
      modalShow: false,
      componenteDinamico: null,
      pagina_actual: 1,
      currentPage: 1,
      currentPageModificado: 1,
      mostrarLoader: false,
      login_user: '',
      consultarfarmaco: null,
      consultarestablecimiento: '',
      establecimientos: [],
      establecimiento: '',
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 3,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },

      fields: [
        { key: 'check',           label: '',                 thClass: 'text-center' },
        { key: 'estado',          label: 'Estado',           sortable: true, thClass: 'text-center', thStyle: { width: '190px' } },
        { key: 'nombre',          label: 'Nombre',           sortable: true, thClass: 'text-center' },
        { key: 'establecimientos', label: 'Establecimientos', sortable: true, thClass: 'text-center' },
        { key: 'cantidad',        label: 'Cantidad Maxima',  sortable: true, thClass: 'text-center' },
        { key: 'precioNeto',      label: 'Precio Neto',      sortable: true, thClass: 'text-center' },
        { key: 'usuario',         label: 'Usuario',          sortable: true, thClass: 'text-center' },
        { key: 'acciones',        label: 'acciones',         sortable: true, thClass: 'text-center', tdClass: 'text-right' },
      ],

      estado: null,
      estados: [
        { value: '1', text: 'Activo' },
        { value: '0', text: 'Inactivo' }
      ],
      listaAcciones: [],
      token_usuario: '',
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'd/m/Y',
      },
      items: [],
      descripcion: '',
      idsMedicaments: [],
    }
  },
  async created() {
    comprobarPermisos(this.$route);
    this.setToken();
    await this.fetchEstablecimientos();
    await this.fetchConsultarFarmaco();
  },

  mounted() {
    actions.setearTitulo('Farmaco')
  },

  methods: {

    async cambiarEstadoIds() {
      if (!this.estado) {
        this.$swal.fire({
          icon: "info",
          text: "Por favor, seleccione un estado."
        })
      } else if (this.estado && this.idsMedicaments.length === 0) {
        this.$swal.fire({
          icon: "info",
          text: "Por favor, seleccione un medicamento."
        })
      } else {
        const query = ` 
          mutation CambiarEstadoMedicamentos($medicamentoDatos: MedicamentoEstadoInput!) 
          {
            cambiarEstadoMedicamento(medicamentoDatos: $medicamentoDatos) {
              status
              message
            }
          } 
        `;


        const variables = {
          medicamentoDatos :{
            id : this.idsMedicaments,
            estado : this.estado,
          }
        }

        try {
            
          const response = await axios.post(rutas.axios + 'api', { query, variables });
          
          if (response.data.data.cambiarEstadoMedicamento.status === 'SUCCESS'){
            await this.$swal.fire({
              title: 'Exito',
              icon: 'success',
              text : 'Estado de medicamentos actualizados correctamente!'
            })
            this.$router.go(0)
          }
        } catch (error) {
          console.error('Erro:', error);
        }
      }
    },

    selectedMedicament(id) {
      const index = this.idsMedicaments.indexOf(id);

      if (index !== -1) {
        this.idsMedicaments.splice(index, 1);
      } else {
        this.idsMedicaments.push(id);
      }
    },


    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
    },

    cambiarPagina(paginaActual) {
      this.currentPage = paginaActual;
      const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
      this.fetchConsultarFarmaco(this.consultarfarmaco ? this.consultarfarmaco : '', this.currentPage, establecimientoValue, this.perPage, this.estado);
    },

    async descargarCartFar() {
      this.descargandoExcel = true
      this.currentPage = 1;
      const excel = '1'
      const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
      await this.fetchConsultarFarmaco(this.consultarfarmaco ? this.consultarfarmaco : '', this.currentPage, establecimientoValue, this.perPage, this.estado, excel );
      this.descargandoExcel = false
    },

    async fetchEstablecimientos() {
      const query = `
        query {
          allEstablecimientos {
            id
            Descripcion
            uniCodigo
          }
        }
      `;
      try {
        const response = await axios.post(rutas.axios + 'api', { query });
        this.establecimientos = response.data.data.allEstablecimientos.map(item => ({
          value: item.id,
          text: item.Descripcion,
          uniCodigo: item.uniCodigo
        }));
      } catch (error) {
        console.error('An error occurred while fetching the options:', error);
      }
    },

    async fetchConsultarFarmaco(search = '', pagina_actual = 1, establecimiento = '', pageSize, estado, excel) {

      const query = `
        query GetAllMedicamentos($search: String, $estado: String, $establecimiento: String, $page: Int, $pageSize: Int, $excel: String) {
          allMedicamentos(search: $search, estado : $estado, establecimiento: $establecimiento, page: $page, pageSize: $pageSize, excel : $excel) {
            total
            status
            message
            dataarchivo
            medicamentos {
              id
              estado
              token
              nombre
              establecimiento
              estadoJson
              usuarioCreador {
                id
                username
              }

              precioNeto
              precioTecho
              numMax
            }
            pageInfo {
              currentPage
              totalPages
              hasNextPage
              hasPreviousPage
            }
          }
        }
        `;

      const variables = {
        search: search,
        page: pagina_actual,
        pageSize: pageSize,
        establecimiento: establecimiento.toString(),
        estado : estado,
        excel : excel
      };

      try {
          
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        
        if (response.status === 200) {
          if (response.data.data.allMedicamentos.status === 'Success') {
            const dataarchivo = response.data.data.allMedicamentos.dataarchivo
      
      if(excel === '1'){
        actions.cargarArchivos(dataarchivo, "CarteraFarmacos.xlsx", "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64")
        return
      }
            if (response.data.data.allMedicamentos.medicamentos) {
              this.items = response.data.data.allMedicamentos.medicamentos.map(item => {
                const estadoJson = this.parseFlexibleJson(item.estadoJson);
                const establecimientos = this.buildEstablecimientos(item.establecimiento);
                return {
                  idMedicamento   : item.id,
                  tokenMedicamento: item.token,
                  establecimiento : item.establecimiento,
                  establecimientos,
                  nombre          : item.nombre,
                  cantidad        : item.numMax,
                  precioNeto      : item.precioNeto,
                  estado          : item.estado,
                  estadoJson,
                  usuario         : item.usuarioCreador ? item.usuarioCreador.username : "No disponible"
                };
              });

              this.totalRows = response.data.data.allMedicamentos.total;
              this.currentPage = 1;
              this.currentPageModificado = pagina_actual
            } else {
              console.log("No se encontraron medicamentos");
            }
          } else {
            console.log("Error en la respuesta del servidor");
            // Manejo del error de respuesta del servidor
          }
        }
      } catch (error) {
        console.error("Error fetching medicamentos:", error);
        // Aquí también podrías mostrar un mensaje de error en la interfaz de usuario
      }
    },
    buildEstablecimientos(establecimientoStr) {
      const estabMap = (this.establecimientos || [])
        .filter(opt => opt && opt.value !== null && opt.value !== undefined)
        .reduce((acc, opt) => {
          acc[String(opt.value)] = opt.text;
          return acc;
        }, {});

      const estIds = (establecimientoStr || '')
        .split(',')
        .map(e => e.trim())
        .filter(Boolean);

      return Object.entries(estabMap).map(([id, nombreEst]) => ({
        id,
        nombre: nombreEst,
        activo: estIds.includes(id)
      }));
    },
    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value
            .replace(/'/g, '"')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (error) {
          console.warn('No se pudo parsear JSON flexible', value);
          return {};
        }
      }
    },

    buscarFarmaco() {
      const establecimientoValue = this.consultarestablecimiento ? this.consultarestablecimiento.toString() : '';
      this.fetchConsultarFarmaco(this.consultarfarmaco, this.currentPage, establecimientoValue, 15, this.estado);
    },

    viewItem(tokenMedicamento) {
      this.tokenSeleccionado = tokenMedicamento;
      this.modalShow = true;
    },

    cargarComponente() {
      // Cargar dinámicamente el componente cuando se muestra el modal
      import('./Verfarmaco.vue').then(componente => {
        this.componenteDinamico = componente.default;
      }).catch(error => {
        console.error('Error al cargar el componente:', error);
      });
    },

    editItem(tokenMedicamento) {
      this.tokenSeleccionado = tokenMedicamento;
      this.$bvModal.show('modal-editar-farmaco')
    },

    removeItemid(idFarmaco) {
      const mesa = this.fetchRemoveMedicamento(idFarmaco);
    },

    async fetchRemoveMedicamento(idFarmaco) {
        console.log(idFarmaco)
        this.$swal({
            title: 'Estas seguro de eliminar este medicamento?',
            text: "No seras capaz de revertir esto!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Borrar esto!',
            cancelButtonText: 'No, cancelar!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                // Call the API or method to remove the item here
                try {
                    const argFarm = {
                        id: idFarmaco,
                    }
                    const response = await axios.post(rutas.axios + 'api', {
                        query: `mutation EliminarMedicamento($id: String!) {
                                    removerMedicamento(medicamentoDatos: { id: $id }) {
                                        status
                                        message
                                    }
                                } 
                                `,
                        variables: argFarm
                    });
                    if (response.status === 200) {
                        if (response.data.data.removerMedicamento.status === 'success') {
                            if (response.status === 200) {
                                this.$swal({
                                    title: 'Borrado!',
                                    text: 'Tu registro ha sido eliminado',
                                    icon: 'success',
                                    confirmButtonColor: '#3085d6'
                                }).then((result) => {
                                    // This will only run when the user presses "OK" on the "Deleted!" modal
                                    if (result.isConfirmed) {
                                        this.$router.go(0);
                                    }
                                });
                            }
                            this.$router.push({ name: 'consultar_cartera_farmaco' }).catch(err => {
                                if (err.name !== 'NavigationDuplicated') {
                                    console.error(err);
                                }
                            });
                        } else {
                            this.$swal({
                                title: 'Error',
                                text: response.data.data.removerMedicamento.message,
                                icon: 'error',
                                confirmButtonColor: '#089599',
                            })
                        }
                    }
                } catch (err) {
                    console.log(err);
                    return 'Error al eliminar doctor';
                }
            } else {
                // User clicked the cancel button
                this.$swal({
                    title: 'Cancelado',
                    text: 'Your registro esta seguro :)',
                    icon: 'error',
                    confirmButtonColor: '#3085d6'
                });
            }
        });
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem('usuario'))
      this.login_user = user.username
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
  },

}
</script>
